// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.workspace-module-container[data-v-bb6ed5da] {\n    background-color: #f2f2f2;\n    user-select: none;\n}\n#projects-container[data-v-bb6ed5da] {\n    padding: 50px 0 0 40px;\n}\n", ""]);
// Exports
module.exports = exports;
